export default "__VITE_PUBLIC_ASSET__1f2b5e61__"